import InterislandPage from '../containers/Interisland/Interisland';  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers'
 
const Express = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <InterislandPage />  
                </main> 
            </MainContainer>
        </>
    )
}

export default Express
